import styled, { css } from 'styled-components'

import { mobileMediaQuery } from '@subaio/webapp'

export const ButtonGroup = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 12px;
	margin-top: 12px;

	${mobileMediaQuery(css`
		flex-direction: column-reverse;
		justify-content: stretch;
		align-items: stretch;
	`)}
`
